import { PropsWithChildren } from 'react'

import { MeetingsContextDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { MeetingsContext } from '../MeetingsContext'

export const MeetingsContextProvider = ({ children }: PropsWithChildren) => {
  const { data, loading } = useQuery(MeetingsContextDocument)

  const value = {
    canSeeMeetings: data?.meetings._policies.seeMeetings.can || false,
    loading,
  }

  return <MeetingsContext.Provider value={value}>{children}</MeetingsContext.Provider>
}
